var windowObjectReference = null;
$(() => {
  $('span.btn-share').on('click', (e) => {
    var href = $(this).data('href');
    if (!href) {
      href = $(e.currentTarget).data('href');
    }
    var w = 500;
    var h = 400;
    var left = (screen.width / 2) - (w / 2);
    var top = (screen.height / 2) - (h / 2);
    var windowFeatures = 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, top=' + top + ',left=' + left + ',width=' + w + ',height=' + h;

    // console.error('span.btn-share', href, e, $(e.currentTarget));
    // if(windowObjectReference == null || windowObjectReference.closed) {
    windowObjectReference = window.open(href, 'windowShareRS', windowFeatures);
    // } else {
    //   windowObjectReference.focus();
    // }
  });
});